import { useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetDepartment } from "@type/api/user";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetDepartmentProps {
  enabled?: boolean;
}

export const useGetDepartment = ({ enabled }: UseGetDepartmentProps) => {
  const [departmentOptions, setDepartmentOptions] = useState<TInputTag[]>([]);

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetDepartment._key(),
    enabled: enabled,
    queryFn: () => queryGetDepartment(),
    onSuccess: (res) => {
      const departmentList: TInputTag[] = res.data.departments.map((dept) => ({
        id: dept.id,
        name: dept.name,
      }));
      departmentList.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      setDepartmentOptions(departmentList);
    },
  });

  return {
    isloadingDepartmentOptions: isLoading,
    departmentOptions,
  };
};
